import React from 'react';
import { RouteObject } from 'react-router-dom';
import { GlobalReportPage } from './views/GlobalReportPage';

export const routes: RouteObject[] = [
  { path: 'global-report', element: <GlobalReportPage /> },
];

export default routes;
